import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Modal informativo de nivel bajo de papel de la impresora de pases de abordar
 * (ATB Printer) — CI-23161.
 *
 * Es meramente informativo y NO bloqueante:
 * - No navega.
 * - No inicia, cancela ni termina ningún flujo.
 * - No altera la condición física del papel ni el dispositivo.
 * - Se cierra únicamente con el CTA `Continuar`.
 *
 * El ciclo de vida de la presentación (una sola vez por visita a Home, y de nuevo
 * en cada regreso a Home mientras el papel siga bajo) lo gobierna
 * `BoardingPassPaperService`; este componente solo renderiza y acusa el cierre.
 *
 * El símbolo de advertencia se representa con el icono aprobado `Alert-icon.svg`,
 * siguiendo el patrón visual existente del repositorio.
 */
@Component({
  selector: 'app-boardingpass-low-paper-modal',
  templateUrl: './boardingpass-low-paper-modal.component.html',
  styleUrls: ['./boardingpass-low-paper-modal.component.scss'],
  standalone: false,
})
export class BoardingPassLowPaperModalComponent {
  readonly titleKey = 'boardingPassPaper.lowTitle';
  readonly ctaKey = 'boardingPassPaper.lowCta';
  readonly icon = 'assets/images/Alert-icon.svg';

  constructor(private readonly activeModal: NgbActiveModal) {}

  /** CTA `Continuar`: cierra el modal. No navega ni altera ningún flujo. */
  onContinue(): void {
    this.activeModal.close();
  }
}
